export const CREATE_PAYMENT = "CREATE_PAYMENT"
export const TOGGLE_GET_STATE = "TOGGLE_GET_STATE"
export const PAYMENT_SUCCESS = "PAYMENT_SUCCESS"
